var is_Finished = false;

(function ($) {

    $(() => {
        $('#toParents').click(function () {
            if ($(this).prop('checked')) {
                $.cookie('minimaxisadult', true, { path: '/' });
            } else {
                $.cookie('minimaxisadult', false, { path: '/' });
            }
            $('body').toggleClass('adult');
        });

        objectFitImages();

        let sticky = '';
        const easters = [];
        if ($(".iframe-modal").length) {
            $(".iframe-modal").iziModal({
                
                history: false,
                iframe: true,
                fullscreen: true,
                headerColor: '#000000',
                openFullscreen: false,
                focusInput: false,
                appendTo: '.modals-wrapper',
                onOpening: function () {
                    $('.iframe-modal').find('iframe').attr('allowfullscreen', 'allowfullscreen');
                }
            });
        }


 
        const $aside = $('aside');
        if ($aside.length) {
            sticky = new StickySidebar('.aside-content-wrapper', {
                topSpacing: 0,
                bottomSpacing: 0,
                containerSelector: 'aside',
                innerWrapperSelector: '.inner-wrapper-sticky',
                resizeSensor: true,
                minWidth: 991
            });

            $('#slicker').on('init', () => {
                sticky.updateSticky();
            });

            const autoplaySpeed = 0;
            let autoplayOn = false;
            let rightDir = false;

            const $slicker = $('#slicker');

            $slicker.on('init', () => {
                const $slickNext = $slicker.find('.slick-next');
                const $slickPrev = $slicker.find('.slick-prev');

                $slickNext.mouseenter(() => {
                    rightDir = false;
                    autoplayOn = true;
                });

                $slickNext.mouseleave(() => {
                    autoplayOn = false;
                });

                $slickPrev.mouseenter(() => {
                    rightDir = true;
                    autoplayOn = true;
                });

                $slickPrev.mouseleave(() => {
                    autoplayOn = false;
                });

                window.setInterval(() => {
                    if (!autoplayOn) return false;
                    if (autoplayOn && window.innerWidth >= 1200) {
                        if (rightDir === false) {
                            $slicker.slick('slickNext');
                        } else {
                            $slicker.slick('slickPrev');
                        }
                    }
                }, autoplaySpeed);
            });

            $('#slicker').slick({
                dots: false,
                arrows: true,
                infinite: true,
                slidesToShow: 5,
                slidesToScroll: 1,
                vertical: true,
                verticalSwiping: true,
                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 12,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 10,
                            slidesToScroll: 3,
                        }
                    },
                    {
                        breakpoint: 769,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 7,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 8,
                        }
                    },
                    {
                        breakpoint: 450,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 6,
                        }
                    },
                    {
                        breakpoint: 380,
                        settings: {
                            vertical: false,
                            verticalSwiping: false,
                            slidesToShow: 5,
                        }
                    },
                ]
            });

            $(window).on('resize orientationchange', () => {
                // only works on ID!
                $('#slicker').slick('refresh');
            });

            if ($('.pagination__next').length) {
                $('.infinite-scroll').infiniteScroll({
                    path: '.pagination__next',
                    append: '.infinite-scroll_row',
                    history: false,
                    status: '.page-load-status'
                });

                $('.infinite-scroll').on('append.infiniteScroll', (event, response, path, items) => {
                    sticky.updateSticky();
                });
            }

            $('#showsTab a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
                sticky.updateSticky();
            });

            if ($('.related-iframe').length) {

                $('.iframe-wrapper .related-iframe').on('click', function (e) {
                    e.preventDefault();
                    const $that = $(this);

                    if (!$(this).hasClass('already_played')) {
                        while ($that.firstChild) {
                            $that.removeChild($that.firstChild);
                        }
                        $that.append(`<iframe src="${$(this).attr('href')}"></iframe>`);
                        $that.addClass('already_played');
                    }
                });
            }

            window.animationEnd = function () {
                $('.easter-egg').remove();
            };

            $(document).on('click', '.start-easter', function () {
                is_Finished = false;

                var $iframe = $('<iframe/>', {
                    name: `frame${$(this).data('egg')}`,
                    id: `frame${$(this).data('egg')}`,
                    class: 'easter-egg',
                    src: $(this).data('href')
                }).appendTo('body');
                $('body').addClass('easter-layer');

                var timer = setInterval(function () {
                    if (is_Finished) {
                        $iframe.remove();
                        $('body').removeClass('easter-layer');
                        clearInterval(timer);
                    }
                }, 100);
            });

        }
    });
})(jQuery);
